var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{attrs:{"no-gutters":""}},[_c('Logo')],1),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('nuxt')],1)],1),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }